import CrudService from "../core/crud-service";

export default class InvitesService extends CrudService {
  static route = "api/v1/invites";

  async findByCode(code: string) {
    return await this.httpService.get<any>(`${this.path}/${code}`);
  }
}
